import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import PublicMenu from "./pages/PublicMenu";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Categories from "./pages/admin/Categories";
import Products from "./pages/admin/Products";
import ServiceCalls from "./pages/admin/ServiceCalls";
import QRAreas from "./pages/admin/QRAreas";
import Settings from "./pages/admin/Settings";
import Media from "./pages/admin/Media";
import Users from "./pages/admin/Users";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-zbeach-bg text-zbeach-muted">Yükleniyor...</div>;
  if (!user) return <Navigate to="/admin-login" replace />;
  return children;
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors closeButton theme="light" />
          <Routes>
            <Route path="/" element={<Navigate to="/menu" replace />} />
            <Route path="/menu" element={<PublicMenu />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="categories" element={<Categories />} />
              <Route path="products" element={<Products />} />
              <Route path="service-calls" element={<ServiceCalls />} />
              <Route path="qr-areas" element={<QRAreas />} />
              <Route path="settings" element={<Settings />} />
              <Route path="media" element={<Media />} />
              <Route path="users" element={<Users />} />
            </Route>
            <Route path="*" element={<Navigate to="/menu" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
